export default __webpack_public_path__ + "static/media/shania-torik.a32f6c4f.png";